import { ArrowLeft, ArrowRight, RotateCcw } from 'lucide-react';

interface WizardNavigationProps {
  canGoPrev: boolean;
  canGoNext: boolean;
  isLastStep: boolean;
  helperMessage?: string;
  onPrev: () => void;
  onNext: () => void;
  onRestart?: () => void;
  isMobile: boolean;
}

export default function WizardNavigation({
  canGoPrev,
  canGoNext,
  isLastStep,
  helperMessage,
  onPrev,
  onNext,
  onRestart,
  isMobile,
}: WizardNavigationProps) {
  const nextLabel = isLastStep ? 'Recommencer' : 'Suivant';
  const handleNextClick = () => {
    if (isLastStep) {
      onRestart?.();
    } else {
      onNext();
    }
  };

  if (isMobile) {
    return (
      <div
        className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.04)] z-40"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        {helperMessage && (
          <p className="text-center text-xs text-gray-500 pt-2 px-4">{helperMessage}</p>
        )}
        <div className="flex gap-3 px-4 py-3">
          <button
            type="button"
            onClick={onPrev}
            disabled={!canGoPrev}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-xl border border-gray-300 bg-white text-gray-700 font-semibold text-sm disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <ArrowLeft className="w-4 h-4" />
            Précédent
          </button>
          <button
            type="button"
            onClick={handleNextClick}
            disabled={!isLastStep && !canGoNext}
            className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-xl font-semibold text-sm transition-colors ${
              (isLastStep || canGoNext)
                ? 'bg-emerald-600 text-white hover:bg-emerald-700'
                : 'bg-emerald-200 text-white cursor-not-allowed'
            }`}
          >
            {isLastStep ? <RotateCcw className="w-4 h-4" /> : null}
            {nextLabel}
            {!isLastStep && <ArrowRight className="w-4 h-4" />}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="border-t border-gray-100 pt-5 mt-6">
      <div className="flex items-center justify-between gap-4">
        <button
          type="button"
          onClick={onPrev}
          disabled={!canGoPrev}
          className="flex items-center gap-2 px-5 py-3 rounded-xl border border-gray-300 bg-white text-gray-700 font-semibold text-sm hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Précédent
        </button>

        <div className="flex-1 text-center">
          {helperMessage && (
            <p className="text-xs text-gray-500">{helperMessage}</p>
          )}
        </div>

        <button
          type="button"
          onClick={handleNextClick}
          disabled={!isLastStep && !canGoNext}
          className={`flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm transition-colors ${
            (isLastStep || canGoNext)
              ? 'bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm'
              : 'bg-emerald-200 text-white cursor-not-allowed'
          }`}
        >
          {isLastStep ? <RotateCcw className="w-4 h-4" /> : null}
          {nextLabel}
          {!isLastStep && <ArrowRight className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );
}
